// extracted by mini-css-extract-plugin
export default {"root":"BannerDiscountMessageBlock_root__bme5X","upgrade":"BannerDiscountMessageBlock_upgrade__ITonX"};